import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  getPlatforms,
} from "@ionic/react";
import "driver.js/dist/driver.css";
import React, { Dispatch, useContext, useEffect, useState } from "react";
import { RouteProps } from "react-router-dom";
import { CMEDRoutes } from "../../PlatformsSwitcher/Constants";
import UserPreferencesContext from "../../../components/contexts/UserPreferencesContext";
import { homeScreen } from "../../../driverTitleAndDesc";
import { globalDriverJsFunction } from "../../../globalDriverConfig";
import "./MarketData.css";
import MarketDataContent, { CMEDPermissions } from "./MarketDataContent";

// import SideMenuNav from '../../../pages/SideMenuNav/SideMenuNav';

interface MarketDataProps extends RouteProps {
  isCMEDLoggedIn: boolean;
  userCMEDEntitlements: CMEDPermissions | undefined;
  setSendRequest: Dispatch<any>;
  sendRequest: any[];
  isUserSettingsModalOpen: any;
  currentSelectedProfile: number | undefined;
}

const MarketData: React.FC<MarketDataProps> = (props: any) => {
  const isDesktopMode = getPlatforms().includes("desktop");
  const [updatedUserPrefData, setUpdatedUserPrefData] = useState(false);

  const { userPreferences, setUserPreferences } = useContext(
    UserPreferencesContext,
  );

  useEffect(() => {
    setUserPreferences(userPreferences);
  }, [updatedUserPrefData]);

  useEffect(() => {
    if (userPreferences.tradinggridgroupsorder) {
      if (userPreferences.app_tour !== "") {
        if (
          typeof userPreferences.app_tour == "string" &&
          window.location.pathname === CMEDRoutes.MARKET_DATA &&
          JSON.parse(userPreferences.app_tour).market === false
        ) {
          const driverData = {
            type: "market",
            steps: homeScreen,
            userPreferences: userPreferences,
            setUserPreferences: setUserPreferences,
            setUpdatedUserPrefData: setUpdatedUserPrefData,
            updatedUserPrefData: updatedUserPrefData,
          };
          setTimeout(() => {
            globalDriverJsFunction(driverData);
          }, 300);
        }
      }
    }
  }, [
    userPreferences.app_tour,
    props.isUserSettingsModalOpen,
    userPreferences.tradinggridgroupsorder,
  ]);

  return (
    <IonPage>
      <IonHeader className="ion-no-border">
        <IonToolbar>
          <IonTitle></IonTitle>
        </IonToolbar>
      </IonHeader>
      <MarketDataContent
        isCMEDLoggedIn={props.isCMEDLoggedIn}
        userCMEDEntitlements={props.userCMEDEntitlements}
        setSendRequest={props.setSendRequest}
        sendRequest={props.sendRequest}
        currentSelectedProfile={props.currentSelectedProfile}
      />
    </IonPage>
  );
};

export default MarketData;
